import { EventEmitter, Injectable } from '@angular/core';
import { TestItem } from '../../interfaces';
import { ContinueToPayComponent } from '../module-show/module-show-components/continue-to-pay/continue-to-pay.component';
import { UiServices } from 'src/app/services/ui-services';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ModuleTestService {
  public emitTestId$ = new EventEmitter<TestItem['id']>();

  constructor(private uiSv: UiServices, private navCtrl: NavController) {}

  async showReasonModal(test: TestItem, inscriptionId: string) {
    let message = test[test.reazon];
    let moduleId = undefined;
    let showCancelBtn = true;
    if (test.reazon === 'condicionalTest') {
      message = `Test: ${test[test.reazon]?.name} del Modulo: ${
        test[test.reazon]?.module?.name
      }`;
      moduleId = test[test.reazon]?.module?.id;
    } else if (test.reazon === 'condicionalModule') {
      message = test[test.reazon]?.name;
      moduleId = test[test.reazon]?.id;
    } else if (test.reazon === 'learningLesson') {
      message = test[test.reazon]?.name;
      moduleId = test[test.reazon]?.learningModuleId;
    }

    if (test.reazon === 'suspendedPlan') {
      showCancelBtn = false;
      message = '';
    }
    const { data } = await this.uiSv.showModal(
      ContinueToPayComponent,
      {
        type: test.reazon,
        extraMsg: message,
        showCancelBtn,
      },
      'continue-to-pay'
    );

    if (test.reazon === 'suspendedPlan') {
      await this.navCtrl.navigateRoot('/virtual-class');
      return;
    }
    if ((test as any).subscriptionId && test.reazon !== 'condicionalDues') {
      await this.navCtrl.navigateRoot(`/virtual-class/${inscriptionId}`);
      return;
    }
    if (data) {
      if (test.reazon === 'condicionalDues') {
        // if ((test as any).subscriptionId) {
        //   this.returnToModule(test, inscriptionId);
        //   return;
        // }
        await this.navCtrl.navigateRoot(`/inscriptions`, {
          queryParams: {
            id: inscriptionId,
          },
        });
        return;
      }
      if (
        test.reazon === 'condicionalTest' ||
        test.reazon === 'condicionalModule' ||
        test.reazon === 'learningLesson'
      ) {
        await this.navCtrl.navigateRoot(
          `/virtual-class/module/${inscriptionId}/${moduleId}`
        );
        return;
      }
    }

    if (test.reazon === 'pending' || test.reazon === 'decline') {
      await this.navCtrl.navigateRoot(`/virtual-class/${inscriptionId}`);
      return;
    }
    this.returnToModule(test, inscriptionId);
  }

  async returnToModule(test: any, inscriptionId: string) {
    if ((test as any)?.subscriptionId) {
      await this.navCtrl.navigateRoot(`/virtual-class/${inscriptionId}`);
      return;
    }
    await this.navCtrl.navigateRoot(
      `/virtual-class/module/${inscriptionId}/${
        test.learningModuleId || test.condicionalModuleId
      }`
    );
  }
}
